import { PayloadAction } from '@reduxjs/toolkit';
import {
  AddToCartState,
  DiscAddToCartInput,
  FrameAddToCartInput,
  RingAddToCartInput,
  StripAddToCartInput,
} from './types';

export const reducers = {
  addRingToCart(
    state: AddToCartState,
    action: PayloadAction<RingAddToCartInput>,
  ) {
    state.isLoading = true;
    state.data = false;
    state.error = null;
  },
  addFrameToCart(
    state: AddToCartState,
    action: PayloadAction<FrameAddToCartInput>,
  ) {
    state.isLoading = true;
    state.data = false;
    state.error = null;
  },
  addStripToCart(
    state: AddToCartState,
    action: PayloadAction<StripAddToCartInput>,
  ) {
    state.isLoading = true;
    state.data = false;
    state.error = null;
  },
  addDiscToCart(
    state: AddToCartState,
    action: PayloadAction<DiscAddToCartInput>,
  ) {
    state.isLoading = true;
    state.data = false;
    state.error = null;
  },
  addToCartSuccess(state: AddToCartState, action: PayloadAction<boolean>) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  addToCartFail(state: AddToCartState, action: PayloadAction<string>) {
    state.isLoading = false;
    state.data = false;
    state.error = action.payload;
  },
};
